<template>
  <div class="auth-layout">
    <div class="promo-section">
      <div class="promo-content">
        <div class="promo-text-top">
          <div class="promo-title-main">Más comunicación</div>
          <div class="promo-title-accent">más confianza</div>
        </div>
        <div class="promo-animation">
          <img
            src="/loginimg.png"
            alt="Ilustración de login"
            style="width: 100%; height: auto; pointer-events: none;"
          />
        </div>
      </div>
    </div>
    <div class="form-section">
      <v-card class="outer-card" flat>
        <div class="logo-container">
          <v-img
            src="/brightlogo.png"
            class="logo-image"
            contain
          />
        </div>
        <v-card 
          class="inner-card gradient-card" 
          flat
          :style="gradientCardStyle"
        >
          <slot />
        </v-card>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('app', ['product']),
    gradientCardStyle() {
      return {
        boxShadow: '0 0 8px rgba(0, 0, 0, 0.08), 0 0 16px rgba(0, 0, 0, 0.06), 0 0 24px rgba(0, 0, 0, 0.04), 0 0 32px rgba(0, 0, 0, 0.02)'
      }
    }
  },
  methods: {
    toEnviamas() {
      window.location.href = 'https://enviamas.pe'
    }
  }
}
</script>

<style scoped>
.auth-layout {
  display: flex;
  flex-direction: row;
  min-height: 100vh;
  width: 100%;
}
.promo-section {
  display: none;
  flex: 0 0 50%;
  background-color: #ffffff;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px;
  min-width: 0;
}
@media (min-width: 960px) {
  .promo-section {
    display: flex;
  }
}
.promo-content {
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.promo-text-top {
  margin-bottom: 50px;
}
.promo-title-main {
  font-size: 32pt;
  font-family: 'New Order', sans-serif;
  font-weight: 700;
  color: #19191a;
  line-height: 1.1;
  margin-bottom: 4px;
}
.promo-title-accent {
  font-size: 36pt;
  font-family: 'New Order', sans-serif;
  font-weight: 700;
  background: linear-gradient(90deg, #E65100 0%, #FFB300 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  line-height: 1.1;
}
  .promo-animation {
    max-width: 380px;
    width: 100%;
    margin: 0 auto;
  }
  .form-section {
    flex: 0 0 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #F2F2F2;
    padding: 16px;
    min-width: 0;
    box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
  }
@media (max-width: 959px) {
  .form-section {
    flex: 1;
  }
}
.outer-card {
  background-color: #F2F2F2 !important;
  border-radius: 16px !important;
  padding: 50px 60px;
  max-width: 700px;
  width: 100%;
}
.logo-container {
  display: flex;
  justify-content: center;
  margin-bottom: 32px;
  margin-top: 16px;
}
.logo-image {
  max-width: 255px;
  height: auto;
}
.logo-image >>> img {
  object-fit: contain;
  max-width: 255px;
  height: auto;
}
  .inner-card {
    background-color: #ffffff !important;
    border-radius: 16px !important;
    padding: 32px;
    max-width: 500px;
    margin: 0 auto;
    border: none !important;
  }
  .inner-card.gradient-card {
    box-shadow: 
      0 0 8px rgba(0, 0, 0, 0),
      0 0 16px rgba(0, 0, 0, 0.06),
      0 0 24px rgba(0, 0, 0, 0.05),
      0 0 32px rgba(0, 0, 0, 0.04) !important;
  }

@media (max-width: 959px) {
  .outer-card {
    border-radius: 22px !important;
    padding: 11px;
    max-width: 400px;
  }
  .logo-container {
    margin-bottom: 33px;
    margin-top: 0;
  }
  .logo-image {
    width: 100%;
    max-width: 220px;
    height: 50px;
  }
  .logo-image >>> img {
    object-fit: contain;
    width: 100%;
    max-width: 220px;
    height: 50px;
  }
  .inner-card {
    padding: 32px;
    max-width: 100%;
    max-height: none;
    min-height: auto;
  }
}
</style>
